// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AccordionController from './accordion_controller'
application.register('accordion', AccordionController)

import ClipboardController from './clipboard_controller'
application.register('clipboard', ClipboardController)

import DisableOnSubmitController from './disable_on_submit_controller'
application.register('disable-on-submit', DisableOnSubmitController)

import ElLoadingController from './el_loading_controller'
application.register('el-loading', ElLoadingController)

import ImageUploadPreviewController from './image_upload_preview_controller'
application.register('image-upload-preview', ImageUploadPreviewController)

import MobileNavTogglerController from './mobile_nav_toggler_controller'
application.register('mobile-nav-toggler', MobileNavTogglerController)

import ModalController from './modal_controller'
application.register('modal', ModalController)

import NewAccountFormController from './new_account_form_controller'
application.register('new-account-form', NewAccountFormController)

import PasswordVisibility from '@stimulus-components/password-visibility'
application.register('password-visibility', PasswordVisibility)

import PopoverController from './popover_controller'
application.register('popover', PopoverController)
